import React, {useEffect, useState} from 'react'
import {Button, Typography} from '@mui/material'
import {useHistory, useParams} from 'react-router-dom'
import axios from 'axios'
import { BEHAVIOUR_ASSESSMENT_FORM_INPUTS } from '../../../Notes/Behaviour_Notes/BEHAVIOUR_CONSTANTS'
import {MoonLoader} from 'react-spinners'
import FormWrapper from '../../../../reusable-components/Wrapper/Wrapper'
import {Box} from '@mui/system'
import DynamicForm from '../../../../reusable-components/forms/DynamicForm'
import FrequencyDateRangePicker from '../../../../reusable-components/NoteType/NoteType'
import { toast } from 'react-toastify'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../../setup'

const BehaviourAssesmentForm = () => {
  const {id}: {id: string} = useParams()
  const [formData, setFormData] = useState({})
  const [uiElements, setUiElements] = useState([])
  const [noteData, setNoteData] = useState<any>({
    noteType: '',
  })
  const [loading, setLoading] = useState(false)
  const [behaviorAssessment, setBehaviorAssessment] = useState<any>(null)
  const history = useHistory()
  const authUser = useSelector((state: RootState) => state.auth)
 useEffect(() => {
    const fetchClients = async () => {
      try {
        setLoading(true)
        const responseForNote = await axios.get(`/behavior-assessment/${id}`, {
          params: {
            isDeleted: true,
          }
        })
        const {behaviorAssessment} = responseForNote?.data
        // Store the original behavior assessment data
        setBehaviorAssessment(behaviorAssessment)
        const updatedclients = [
          ...behaviorAssessment?.clients?.map((client) => ({label: client.fullName, value: client._id})),
        ]
        
        // Create the updated data object with all necessary values
        const updatedData = {
          clientId: behaviorAssessment?.clientId,
          behaviorsMapping: behaviorAssessment?.behaviorsMapping,
          initialTargetIds: behaviorAssessment?.initialTargetIds,
          initialReplacementIds: behaviorAssessment?.initialReplacementIds,
          initialTargetBehaviour: behaviorAssessment?.initialTargetBehaviour,
          initialReplacementBehaviour: behaviorAssessment?.initialReplacementBehaviour,
          type1: behaviorAssessment?.disability?.type1,
          type2: behaviorAssessment?.disability?.type2,
          type3: behaviorAssessment?.disability?.type3,
          name: behaviorAssessment?.planPreparedBy?.name,
          name1: behaviorAssessment?.keyContacts[0]?.name || '',
          relationship1: behaviorAssessment?.keyContacts[0]?.relationship || '',
          phoneNumber1: behaviorAssessment?.keyContacts[0]?.phoneNumber || '',
          name2: behaviorAssessment?.keyContacts[1]?.name || '',
          relationship2: behaviorAssessment?.keyContacts[1]?.relationship || '',
          phoneNumber2: behaviorAssessment?.keyContacts[1]?.phoneNumber || '',
          profession: behaviorAssessment?.planPreparedBy?.profession,
          registrationNumber: behaviorAssessment?.planPreparedBy?.registrationNumber,
          type: behaviorAssessment?.type,
          description: behaviorAssessment?.description,
          duration: behaviorAssessment?.duration,
          intensity: behaviorAssessment?.intensity,
          settingEvents: behaviorAssessment?.settingEvents,
          triggers: behaviorAssessment?.triggers,
          lowRiskScenarios: behaviorAssessment?.lowRiskScenarios,
          highRiskScenarios: behaviorAssessment?.highRiskScenarios,
          function: behaviorAssessment?.function,
          replacementBehaviour: behaviorAssessment?.replacementBehaviour,
          behaviouralGoals: behaviorAssessment?.behaviouralGoals,
          baselineAndPreventionLooksLike: behaviorAssessment?.baselineAndPrevention?.looksLike,
          baselineAndPreventionParticipantCanDo: behaviorAssessment?.baselineAndPrevention?.participantCanDo,
          baselineAndPreventionSupportTeamCanDo: behaviorAssessment?.baselineAndPrevention?.supportTeamCanDo,
          buildUpLooksLike: behaviorAssessment?.buildUp?.looksLike,
          buildUpParticipantCanDo: behaviorAssessment?.buildUp?.participantCanDo,
          buildUpSupportTeamCanDo: behaviorAssessment?.buildUp?.supportTeamCanDo,
          whenLooksLike: behaviorAssessment?.when?.looksLike,
          whenParticipantCanDo: behaviorAssessment?.when?.participantCanDo,
          whenSupportTeamCanDo: behaviorAssessment?.when?.supportTeamCanDo,
          formulation: behaviorAssessment?.formulation,
          preventativeStrategies: behaviorAssessment?.preventativeStrategies,
          skillBuildingStrategies: behaviorAssessment?.skillBuildingStrategies,
          reinforcementMotivation: behaviorAssessment?.reinforcementMotivation,
          planImplementationSystemSupports: behaviorAssessment?.planImplementationSystemSupports,
        }
        
        // Updated mapping to set values for all fields and disable them
        const updatedFormData = BEHAVIOUR_ASSESSMENT_FORM_INPUTS.map((item) => {
          // For clientId field, set options and value
          if (item.name === 'clientId') {
            return {
              ...item, 
              options: updatedclients, 
              disabled: true,
              value: updatedData.clientId
            }
          }
          
          // For all other fields, set the value from updatedData and disable
          return {
            ...item, 
            disabled: true,
            value: updatedData[item.name] || '' // Use the value from updatedData or empty string if undefined
          }
        })
        
        setFormData(updatedData)
        setNoteData({noteType: behaviorAssessment?.noteType})
        setUiElements(updatedFormData)
      } catch (error) {
        console.error('Error fetching data:', error)
      } finally {
        setLoading(false)
      }
    }
    fetchClients()
  }, [])

  const buttons = [
    {
      label: 'Cancel',
      variant: 'outlined',
      type: 'button',
    },
  ]

  return (
    <>
      {loading ? (
        <div className='overlay d-flex justify-content-center' style={{marginTop: '100px'}}>
          <MoonLoader color='#9db2fc' size={60} loading={loading} />
        </div>
      ) : (
        <FormWrapper
          title='Deleted Behavior Assessment'
          content={
            <>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                  marginRight: '0.5rem',
                }}
              >
                <Button
                  variant='outlined'
                  color='primary'
                  onClick={() => history.goBack()}
                  sx={{marginRight: '10px', marginBottom: '10px'}}
                >
                  Back
                </Button>
              </Box>
              <Typography
                sx={{
                  fontSize: '16px',
                  fontWeight: 'bold',
                  marginBottom: '0.5rem',
                  marginLeft: '1rem',
                }}
                color='primary'
              >
                Note Type
              </Typography>
              <FrequencyDateRangePicker
                isEntry={false}
                isTemplate={false}
                isFullForm={false}
                isEdit={true}
                formData={noteData}
                setFormData={setNoteData}
              />
              <DynamicForm
                fields={uiElements}
                data={formData}
                onSubmit={() => {}}
                buttons={buttons}
                setFormValues={setFormData}
              />
            </>
          }
        />
      )}
    </>
  )
}

export default BehaviourAssesmentForm
